import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-email",
  templateUrl: "./med-icon-email.component.html",
})
export class MedIconEmailComponent extends SvgMixinComponent {}
